import { render, staticRenderFns } from "./weChat_official_account.vue?vue&type=template&id=3a3bd4d8&scoped=true&"
import script from "./weChat_official_account.vue?vue&type=script&lang=js&"
export * from "./weChat_official_account.vue?vue&type=script&lang=js&"
import style0 from "./weChat_official_account.vue?vue&type=style&index=0&id=3a3bd4d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3bd4d8",
  null
  
)

export default component.exports